import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { HeaderService } from '../header/header.service';

@Component({
  selector: 'app-change-ship-warehouse-address',
  templateUrl: './change-ship-warehouse-address.component.html',
  styleUrls: ['./change-ship-warehouse-address.component.scss']
})
export class ChangeShipWarehouseAddressComponent implements OnInit,OnDestroy {
  actions: any[];
  fromWareHouseId: FormControl = new FormControl("", [Validators.required]);
  boxContentSource: FormControl = new FormControl("FEED", [Validators.required]);
  shipmentName: FormControl = new FormControl("", [Validators.required]);
  shipingPrice: FormControl = new FormControl(0, [Validators.required,Validators.min(0)]);
  prepBy: FormControl = new FormControl("seller", [Validators.required]);
  private destroy$ = new Subject<void>();
  accountTypes;
  constructor(
    private shipyardService: ShipyardService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ChangeShipWarehouseAddressComponent>,
    private snackBar : MatSnackBar,
    private headerService: HeaderService
  ) {
    this.data?.prepByAmazon == 'true' ? this.prepBy.setValue('amazon') : this.prepBy.setValue('seller');  
  }

  ngOnInit(): void {
    this.actions = this.data.actions || [
      { text: "Cancel", buttonStyle: "underline"},
      { text: "Confirm",spin:false , isDisabled: (!this.fromWareHouseId.valid && !this.data.isShowPrepBy && !this.data.isShowBoxSource)},
    ];
    if(this.data?.boxContentSource){
      this.boxContentSource.setValue(this.data.boxContentSource);
    }
    if(this.data.isShipingPrice){
      this.shipingPrice.setValue(this.data.shipingPrice || 0)
    }   
    
    this.fromWareHouseId.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      if(res){
        this.actions[1].isDisabled = false;
      }else{
        this.actions[1].isDisabled = true;
      }      
    })
    this.shipmentName.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      if(res){
        this.actions[1].isDisabled = false;
      }else{
        this.actions[1].isDisabled = true;
      }      
    })

    if(this.data?.shipmentName)
    this.shipmentName.setValue(this.data.shipmentName);
    this.headerService.accountSelectedType
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      if (e)  this.accountTypes = e[0];        
    })
    if(!this.fromWareHouseId.valid && this.data.isdeductFrom ) this.actions[1].isDisabled = true;
    else this.actions[1].isDisabled = false;
  }

  action(e?) {
    if(e == 'Confirm'){
        if (this.data?.isShowBoxSource){
          this.updateBoxContentShipment(e)
        } else if(this.data?.isShowPrepBy){
          this.dialogRef.close({
            action : e,        
            prepBy : this.prepBy.value
          });
        } else if(this.data?.isShipmentName ){
          this.updateShipmentName(e);
      } else if(this.data?.isdeductFrom){
        this.deductWarehouse(e)
      } else if(this.data?.isShipingPrice){
        this.updatePrice(e)
      } else {
        this.changeWarehouseAddress(e);
      }
    }
    else{
      this.dialogRef.close(e);
    }    
  }

  changeWarehouseAddress(e){
    this.actions[1].spin = true;
    const payload : any ={
      shipmentHeaderId: this.data.shipmentHeaderId,
      fromWarehouse: this.fromWareHouseId.value.id
    }
   this.shipyardService.UpdateWarehouseShipment(payload).pipe(takeUntil(this.destroy$)).subscribe({
     next: (result: boolean) => {
      if  (result)  {
        
        this.actions[1].spin = false;
        this.dialogRef.close(e);
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Warehouse updated successfully",
              action: 'Dismiss',
              type: 'success',
            },
          }
       );
      } 
      else{
       
        this.actions[1].spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation Unsuccessful",
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    },
     error: (err) => {
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  updateBoxContentShipment(e){
    this.actions[1].spin = true;
    const payload : any ={
      shipmentHeaderId: this.data.shipmentHeaderId,
      boxContentSource: this.boxContentSource.value
    }

    this.shipyardService.UpdateBoxContentShipment(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any[]) => {
      this.actions[1].spin = false;
      this.dialogRef.close(result ? e : "");
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: result ? 'Box content updated successfully' : 'Operation Unsuccessful', 
            action: 'Dismiss',
            type: result ? 'success' : 'error',
          },
        }
     );
    },
     error: (err) => {
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Operation Unsuccessful', 
            action: 'Dismiss',
            type: 'error',
          },
        })
     }
   });
  }

  close(){
    this.dialogRef.close();
  }

  updateShipmentName(e){
    this.actions[1].spin = true;
    const payload : any ={
      shipmentHeaderId: this.data.shipmentHeaderId,
      shipmentName: this.shipmentName.value
    }
    this.shipyardService.UpdateShipmentName(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any[]) => {
        this.actions[1].spin = false;
        this.dialogRef.close(e);
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Shipment Name updated successfully",
              action: 'Dismiss',
              type: 'success',
            },
          }
       );
      },
     error: (error) => {
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  deductWarehouse(e){
    this.actions[1].spin = true;
    const payload : any ={
      shipmentHeaderId: this.data.shipmentHeaderId,
      deductFromWarehouseId: this.fromWareHouseId.value.warehouseId,
      accountType: this.accountTypes
    }
    this.shipyardService.UpdateDeductWarehouseShipment(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any[]) => {
        this.actions[1].spin = false;
        this.dialogRef.close(e);
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Warehouse updated successfully",
              action: 'Dismiss',
              type: 'success',
            },
          }
       );
      },
     error: (error) => {
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  updatePrice(e){
    this.actions[1].spin = true;
    const payload : any ={
      shipmentHeaderId: this.data.shipmentHeaderId,
      shipingPrice: this.shipingPrice.value
    }
    this.shipyardService.updateShipingPrice(payload).pipe(takeUntil(this.destroy$)).subscribe((result: any[]) => {        
      this.actions[1].spin = false;
      this.dialogRef.close(e);
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: "Shipping Price updated successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
     );
    },
    (error)=>{      
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    });
  }
}
